// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"LinkButton_linkButton___JJyv","primary":"LinkButton_primary__EMqf_","secondary":"LinkButton_secondary__Jz3bc","tertiary":"LinkButton_tertiary__LaDVy"};